import React, { useState, useEffect } from "react";
import { Main, Content } from "../../../components/Layout";
import { Col, Row } from "react-bootstrap";
import DatePicker from "../../../components/DatePicker";
import Slct from "../../../components/Slct";
import TabNotification from "../../../components/TabNotification";
import Button from "../../../components/Button";
import Pagenation from "../../../components/Pagenation";
import Loading from "../../../components/Loading";
import EmptyError from "../../../components/EmptyError";
import StatusFlag from "../../../components/StatusFlag";
import TableResponsive from "../../../components/TableResponsive";
import Dropdown2 from "../../../components/Dropdown";
import SpoilerLink from "../../../components/SpoilerLink";
import { Currency, IntegerNumber } from "../../../components/Input";
import getCommercial from "../../../util/getCommercial";
import { toast } from "react-toastify";
import useWrapper from "../../../hooks/useWrapper";
import useFormat from "../../../hooks/utils/useFormat";
import usePermission from "../../../hooks/usePermission";
import useSuppliers from "../../../hooks/api/useSuppliers";
import { listBillsToPay } from "../../../hooks/api/listBillsToPay";
import {
  ModalConfirm,
  ModalBillToPay,
  ModalBillToPayBaixa,
  ModalBillToPayInstallment,
  ModalBillToPayPaymentInfo,
  ModalBillToPayPaidDetails,
} from "../../../components/Modal";
import { METHOD_LABEL, hasPaymentDetails } from "../../../util/paymentMethods";
import Accordion2 from "../../../components/Accordion";
import Tooltip2 from "../../../components/Tooltip";
import api from "../../../services/api";

const PAYMENT_FOR_LABEL = {
  empresa: "Fornecedor",
  turma: "Turma",
  formando: "Formando",
};

const STATUS_LABEL = {
  "a-pagar": "A Vencer",
  pago: "Pago",
  cancelado: "Cancelado",
};

export default function BillsToPay() {
  const { setbreadcrumb, config } = useWrapper();
  const { formatDate, formatReal, formatQuery } = useFormat();
  const canCreate = usePermission("financialCompany", "create");
  const canUpdate = usePermission("financialCompany", "update");
  const canPaymentDown = usePermission("financialCompany", "paymentDown");

  const suppliers = useSuppliers();

  const [isLoadingEssential, setisLoadingEssential] = useState(false);
  const [isLoadingList, setisLoadingList] = useState(false);
  const isWaitingResponse = isLoadingEssential || isLoadingList;

  const [commercials, setcommercials] = useState([]);
  const [costCenters, setcostCenters] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        setisLoadingEssential(true);
        suppliers.load();
        const { data: _cost_centers } = await api.get("cost-center?type=despesa", config);
        setcostCenters(
          [{ value: null, label: "-- Todos --" }].concat(
            _cost_centers?.map(__cost_center => ({
              value: __cost_center.id,
              label: __cost_center.name,
              expensePlan: __cost_center.expensePlan?.map(__expense_plan => ({
                value: __expense_plan.id,
                label: __expense_plan.name,
                expenses: __expense_plan.expenses?.map(__expense => ({
                  value: __expense.id,
                  label: __expense.name,
                })),
              })),
            })),
          ),
        );
        const _commercials = await getCommercial();
        setcommercials(
          [{ value: null, label: "-- Todas --" }].concat(
            _commercials?.map(__commercial => ({
              label: __commercial.label,
              value: __commercial.value,
              trainees: [{ value: null, label: "-- Todos --" }].concat(
                __commercial.trainees?.map(__trainee => ({
                  label: __trainee.name || __trainee.label,
                  value: __trainee.id || __trainee.value,
                })) || [],
              ),
            })),
          ),
        );
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Erro ao tentar carregar alguns dados.");
      } finally {
        setisLoadingEssential(false);
        applyFilter(filter);
      }
    })();
    // roda apenas no mount para carregar selects e aplicar o filtro inicial
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [negotiations, setnegotiations] = useState();
  const filter_init = {
    date_type: "dueInterval",
    status: "a-pagar",
  };
  const [filter, setfilter] = useState(filter_init);

  const applyFilter = async (__filter, __page) => {
    document.querySelector("#page-filter .accordion-button[aria-expanded='true']")?.click();
    try {
      setisLoadingList(true);
      const _filter = __filter || filter;
      if (!!__filter) {
        setfilter(__filter);
      }
      const { date_type, date_start, date_end, ...query } = _filter;
      const _date_range =
        !!date_start || !!date_end
          ? { [date_type]: `${formatDate(date_start, 3) || "null"}|${formatDate(date_end, 3) || "null"}` }
          : null;
      const _query = formatQuery({
        ...query,
        ..._date_range,
        ...(__page ? { page: __page } : {}),
      });
      const _negotiations = await listBillsToPay({
        config,
        query: _query,
      });
      setnegotiations(_negotiations);
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Problemas ao tentar carregar os pagamentos.");
    } finally {
      setisLoadingList(false);
    }
  };

  const [filterTab, setfilterTab] = useState("topay");
  const filterPreset = __preset => {
    if (isWaitingResponse) return false;
    setfilterTab(__preset);
    if (__preset === "all")
      applyFilter({
        date_type: "dueInterval",
      });
    else if (__preset === "topay")
      applyFilter({
        date_type: "dueInterval",
        status: "a-pagar",
      });
    else if (__preset === "overdue")
      applyFilter({
        date_type: "dueInterval",
        overdue: 1,
      });
    else if (__preset === "payed")
      applyFilter({
        date_type: "dueInterval",
        status: "pago",
      });
    else if (__preset === "canceled")
      applyFilter({
        date_type: "dueInterval",
        status: "cancelado",
      });
  };

  useEffect(() => {
    setbreadcrumb([{ label: "Contas a Pagar" }]);
  }, [setbreadcrumb]);

  const [modalNegotiation, setmodalNegotiation] = useState(null);
  // { bill, negotiation }: a baixa mostra os dados de pagamento do título, que
  // ficam no header e não na parcela
  const [baixaBill, setbaixaBill] = useState(null);
  const [editBill, seteditBill] = useState(null);
  const [cancelBill, setcancelBill] = useState(null);
  const [cancelNegotiation, setcancelNegotiation] = useState(null);
  const [deleteNegotiation, setdeleteNegotiation] = useState(null);
  const [paymentInfoNegotiation, setpaymentInfoNegotiation] = useState(null);
  const [paidDetailsBill, setpaidDetailsBill] = useState(null);
  const [isConfirming, setisConfirming] = useState(false);

  const confirmCancelBill = async () => {
    try {
      setisConfirming(true);
      await api.put(`bills-to-pay/cancel/${cancelBill.id}`, {}, config);
      toast.success("Parcela cancelada!");
      setcancelBill(null);
      applyFilter();
    } catch (__error) {
      const _message = __error?.response?.data?.error?.message;
      toast.error(_message || "Problemas ao cancelar a parcela.");
    } finally {
      setisConfirming(false);
    }
  };

  const confirmCancelNegotiation = async () => {
    try {
      setisConfirming(true);
      await api.put(`bill-to-pay-negotiations/cancel/${cancelNegotiation.id}`, {}, config);
      toast.success("Título de pagamento cancelado!");
      setcancelNegotiation(null);
      applyFilter();
    } catch (__error) {
      const _message = __error?.response?.data?.error?.message;
      toast.error(_message || "Problemas ao cancelar o título de pagamento.");
    } finally {
      setisConfirming(false);
    }
  };

  const confirmDeleteNegotiation = async () => {
    try {
      setisConfirming(true);
      await api.delete(`bill-to-pay-negotiations/${deleteNegotiation.id}`, config);
      toast.success("Título de pagamento excluído!");
      setdeleteNegotiation(null);
      applyFilter();
    } catch (__error) {
      const _message = __error?.response?.data?.error?.message;
      toast.error(_message || "Problemas ao excluir o título de pagamento.");
    } finally {
      setisConfirming(false);
    }
  };

  const openComprovante = async __file_id => {
    try {
      const { data: _file } = await api.get(`files/${__file_id}/download`, config);
      window.open(_file?.download);
    } catch (__error) {
      toast.error("Problemas ao baixar o comprovante.");
    }
  };

  const commercialLabel = __commercial => {
    if (!__commercial) return null;
    return (
      __commercial.class_name ||
      `${__commercial.course?.title || "?"} ${__commercial.year}.${__commercial.period} - ${__commercial.institution?.title || "?"}`
    );
  };

  const payeeName = __negotiation => {
    if (__negotiation?.payment_for === "empresa") return __negotiation?.providers?.name || "-";
    if (__negotiation?.payment_for === "formando") return __negotiation?.trainees?.name || "-";
    return commercialLabel(__negotiation?.commercials) || "-";
  };

  const billStatusFlag = __bill => {
    if (__bill.status === "a-pagar") {
      const _due = new Date(__bill.due_date);
      const _today = new Date();
      _today.setHours(0, 0, 0, 0);
      return _due < _today ? "Atrasado" : "A Vencer";
    }
    return STATUS_LABEL[__bill.status] || __bill.status;
  };

  const nextDueStatus = __bill => {
    if (!__bill) return null;
    const _due = new Date(__bill.due_date);
    const _today = new Date();
    _today.setHours(0, 0, 0, 0);
    const _priorityLimit = new Date(_today);
    _priorityLimit.setDate(_priorityLimit.getDate() + 7);
    if (_due < _today) return "Atrasado";
    if (_due <= _priorityLimit) return "Vence em Breve";
    return null;
  };
  const nextDueTooltip = {
    Atrasado: "Esse título possui pagamentos atrasados.",
    "Vence em Breve": "Esse título possui pagamentos vencendo nos próximos 7 dias.",
  };

  const supplierOptions = [{ value: null, label: "-- Todos --" }].concat(
    suppliers?.data?.map(__supplier => ({
      value: __supplier.id,
      label: __supplier.name,
    })) || [],
  );

  const installmentsSpoiler = __negotiation => (
    <TableResponsive
      table={{
        head: [
          { data: "Parcela" },
          { data: "Status" },
          { data: "Vencimento" },
          { data: "Valor" },
          { data: "Valor Pago" },
          { data: "Data do Pagamento" },
          { data: "Comentário" },
          { data: <div className="text-end">Ações</div> },
        ],
        body: __negotiation?.billToPays?.map(__bill => ({
          data: [
            {
              element: (
                <span>
                  {__bill.quotas}/{__negotiation.total_quotas}
                  {__bill.entry ? " (Entrada)" : ""}
                </span>
              ),
            },
            { element: <StatusFlag status={billStatusFlag(__bill)} /> },
            { element: <span>{formatDate(__bill.due_date, 7)}</span> },
            { element: <span>{formatReal(__bill.value)}</span> },
            { element: <span>{__bill.status === "pago" ? formatReal(__bill.value_paid) : "-"}</span> },
            {
              element: (
                <span>
                  {__bill.status === "pago" && __bill.payment_date ? formatDate(__bill.payment_date, 7) : "-"}
                  {__bill.status === "pago" && __bill.userPaid?.username ? ` (${__bill.userPaid.username})` : ""}
                </span>
              ),
            },
            __bill.description
              ? { element: <SpoilerLink text="Comentário" />, spoiler: <p className="mb-0">{__bill.description}</p> }
              : { element: <span>-</span> },
            (() => {
              const _menu = [
                ...(__bill.status === "a-pagar" && canPaymentDown
                  ? [
                      {
                        label: "Confirmar Pagamento",
                        action: () => {
                          setbaixaBill({ bill: __bill, negotiation: __negotiation });
                        },
                      },
                    ]
                  : []),
                ...(__bill.status === "a-pagar" && canUpdate
                  ? [
                      {
                        label: "Editar",
                        action: () => {
                          seteditBill(__bill);
                        },
                      },
                      {
                        label: "Cancelar",
                        action: () => {
                          setcancelBill(__bill);
                        },
                      },
                    ]
                  : []),
                ...(__bill.status === "pago" && hasPaymentDetails(__bill)
                  ? [
                      {
                        label: "Dados do Pagamento",
                        action: () => {
                          setpaidDetailsBill(__bill);
                        },
                      },
                    ]
                  : []),
                ...(__bill.status === "pago" && !!__bill.file_id
                  ? [
                      {
                        label: "Comprovante",
                        action: () => {
                          openComprovante(__bill.file_id);
                        },
                      },
                    ]
                  : []),
              ];
              return {
                element: _menu.length > 0 && (
                  <div className="text-end">
                    <Dropdown2 toggle={<>...</>} menu={_menu} />
                  </div>
                ),
              };
            })(),
          ],
          key: `bill-${__bill.id}`,
        })),
      }}
    />
  );

  return (
    <>
      <Main>
        {!isLoadingEssential ? (
          <Content>
            <ModalBillToPay
              show={!!modalNegotiation?.open}
              negotiation={modalNegotiation?.negotiation}
              onHide={() => {
                setmodalNegotiation(null);
              }}
              refreshCallback={() => {
                applyFilter();
              }}
            />
            <ModalBillToPayBaixa
              show={!!baixaBill}
              bill={baixaBill?.bill}
              negotiation={baixaBill?.negotiation}
              onHide={() => {
                setbaixaBill(null);
              }}
              refreshCallback={() => {
                applyFilter();
              }}
            />
            <ModalBillToPayPaymentInfo
              show={!!paymentInfoNegotiation}
              negotiation={paymentInfoNegotiation}
              onHide={() => {
                setpaymentInfoNegotiation(null);
              }}
              refreshCallback={() => {
                applyFilter();
              }}
            />
            <ModalBillToPayPaidDetails
              show={!!paidDetailsBill}
              bill={paidDetailsBill}
              onHide={() => {
                setpaidDetailsBill(null);
              }}
            />
            <ModalBillToPayInstallment
              show={!!editBill}
              bill={editBill}
              onHide={() => {
                seteditBill(null);
              }}
              refreshCallback={() => {
                applyFilter();
              }}
            />
            <ModalConfirm
              show={!!cancelBill}
              title="Cancelar Parcela"
              text={`Tem certeza que deseja cancelar a parcela ${cancelBill?.quotas}? Essa ação não pode ser desfeita.`}
              confirm={confirmCancelBill}
              closeModal={() => {
                setcancelBill(null);
              }}
              loading={isConfirming}
              colorScheme="error"
            />
            <ModalConfirm
              show={!!cancelNegotiation}
              title="Cancelar Título de Pagamento"
              text="Todas as parcelas em aberto serão canceladas. As parcelas pagas não são alteradas. Tem certeza?"
              confirm={confirmCancelNegotiation}
              closeModal={() => {
                setcancelNegotiation(null);
              }}
              loading={isConfirming}
              colorScheme="error"
            />
            <ModalConfirm
              show={!!deleteNegotiation}
              title="Excluir Título de Pagamento"
              text="O título de pagamento e todas as suas parcelas serão excluídos permanentemente. Tem certeza?"
              confirm={confirmDeleteNegotiation}
              closeModal={() => {
                setdeleteNegotiation(null);
              }}
              loading={isConfirming}
              colorScheme="error"
            />
            <Row>
              <Col sm={7}>
                <h2 className="mini-title">Gerenciar Pagamentos:</h2>
                <p className="small-label mb-4">
                  Pagamentos para fornecedores, turmas e formandos. A baixa é manual e o comprovante é opcional.
                </p>
              </Col>
              <Col sm={5} className="text-end">
                {canCreate && (
                  <Button
                    disabled={isWaitingResponse}
                    onClick={() => {
                      setmodalNegotiation({ open: true });
                    }}
                  >
                    Novo Título de Pagamento
                  </Button>
                )}
              </Col>
            </Row>
            <Accordion2 id="page-filter">
              <Accordion2.Item eventKey={`page-filter`}>
                <Accordion2.Header>
                  <span>Filtro</span>
                  <Accordion2.Extras>
                    <span>{negotiations?.total} resultados</span>
                  </Accordion2.Extras>
                </Accordion2.Header>
                <Accordion2.Body>
                  <Row>
                    <Col sm={4}>
                      <span>Critério de Data</span>
                      <Slct
                        isDisabled={isWaitingResponse}
                        placeholder="..."
                        options={[
                          { value: "dueInterval", label: "Vencimento" },
                          { value: "createInterval", label: "Criação" },
                        ]}
                        value={filter?.date_type}
                        onChange={__ev => {
                          setfilter({
                            ...filter,
                            date_type: __ev.value,
                          });
                        }}
                      />
                    </Col>
                    <Col sm={4}>
                      <span>Data Inicial</span>
                      <DatePicker
                        disabled={isWaitingResponse}
                        selected={filter?.date_start}
                        onChange={__ev => {
                          setfilter({
                            ...filter,
                            date_start: __ev,
                          });
                        }}
                      />
                    </Col>
                    <Col sm={4}>
                      <span>Data Final</span>
                      <DatePicker
                        disabled={isWaitingResponse}
                        selected={filter?.date_end}
                        onChange={__ev => {
                          setfilter({
                            ...filter,
                            date_end: __ev,
                          });
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col sm={4}>
                      <span>Referente à</span>
                      <Slct
                        isDisabled={isWaitingResponse}
                        placeholder="..."
                        options={[
                          { value: null, label: "-- Todos --" },
                          { value: "empresa", label: "Fornecedor" },
                          { value: "turma", label: "Turma" },
                          { value: "formando", label: "Formando" },
                        ]}
                        value={filter?.payment_for}
                        onChange={__ev => {
                          setfilter({
                            ...filter,
                            payment_for: __ev.value,
                            provider_id: null,
                            commercial_id: null,
                            trainee_id: null,
                          });
                        }}
                      />
                    </Col>
                    {filter?.payment_for === "empresa" && (
                      <Col sm={4}>
                        <span>Fornecedor</span>
                        <Slct
                          isDisabled={isWaitingResponse}
                          placeholder="..."
                          options={supplierOptions}
                          value={filter?.provider_id}
                          onChange={__ev => {
                            setfilter({
                              ...filter,
                              provider_id: __ev.value,
                            });
                          }}
                        />
                      </Col>
                    )}
                    {(filter?.payment_for === "empresa" ||
                      filter?.payment_for === "turma" ||
                      filter?.payment_for === "formando") && (
                      <Col sm={4}>
                        <span>Turma</span>
                        <Slct
                          isDisabled={isWaitingResponse}
                          placeholder="..."
                          options={commercials || []}
                          value={filter?.commercial_id}
                          onChange={__ev => {
                            setfilter({
                              ...filter,
                              commercial_id: __ev.value,
                              trainee_id: null,
                            });
                          }}
                        />
                      </Col>
                    )}
                    {filter?.payment_for === "formando" && (
                      <Col sm={4}>
                        <span>Formando</span>
                        <Slct
                          isDisabled={isWaitingResponse}
                          placeholder="..."
                          options={
                            commercials?.find(__commercial => __commercial.value === filter?.commercial_id)?.trainees ||
                            []
                          }
                          value={filter?.trainee_id}
                          onChange={__ev => {
                            setfilter({
                              ...filter,
                              trainee_id: __ev.value,
                            });
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                  <Row className="mt-2">
                    <Col sm={4}>
                      <span>Centro de Custo</span>
                      <Slct
                        isDisabled={isWaitingResponse}
                        placeholder="..."
                        options={costCenters || []}
                        value={filter?.cost_center_id}
                        onChange={__ev => {
                          setfilter({
                            ...filter,
                            cost_center_id: __ev.value,
                            expense_plan_id: null,
                            expense_id: null,
                          });
                        }}
                      />
                    </Col>
                    <Col sm={4}>
                      <span>Plano de Conta</span>
                      <Slct
                        isDisabled={isWaitingResponse}
                        placeholder="..."
                        options={
                          filter?.cost_center_id
                            ? costCenters?.find(__cost_center => __cost_center.value === filter.cost_center_id)
                                ?.expensePlan || []
                            : []
                        }
                        value={filter?.expense_plan_id}
                        onChange={__ev => {
                          setfilter({
                            ...filter,
                            expense_plan_id: __ev.value,
                            expense_id: null,
                          });
                        }}
                      />
                    </Col>
                    <Col sm={4}>
                      <span>Conta</span>
                      <Slct
                        isDisabled={isWaitingResponse}
                        placeholder="..."
                        options={
                          filter?.expense_plan_id
                            ? costCenters
                                ?.find(__cost_center => __cost_center.value === filter.cost_center_id)
                                ?.expensePlan?.find(
                                  __expense_plan => __expense_plan.value === filter.expense_plan_id,
                                )?.expenses || []
                            : []
                        }
                        value={filter?.expense_id}
                        onChange={__ev => {
                          setfilter({
                            ...filter,
                            expense_id: __ev.value,
                          });
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col sm={4}>
                      <span>ID</span>
                      <IntegerNumber
                        disabled={isWaitingResponse}
                        value={filter?.id}
                        valueChange={__ev => {
                          setfilter({
                            ...filter,
                            id: __ev,
                          });
                        }}
                      />
                    </Col>
                    <Col sm={4}>
                      <span>Valor Total</span>
                      <Currency
                        disabled={isWaitingResponse}
                        value={filter?.value_total}
                        valueChange={__ev => {
                          setfilter({
                            ...filter,
                            value_total: __ev,
                          });
                        }}
                      />
                    </Col>
                  </Row>
                  {!isWaitingResponse && (
                    <Row className="mt-3">
                      <Col>
                        <Button
                          color="primary"
                          size="sm"
                          onClick={() => {
                            applyFilter();
                          }}
                        >
                          Aplicar Filtro
                        </Button>
                        <Button
                          color="grey"
                          size="sm"
                          onClick={() => {
                            applyFilter(filter_init);
                            setfilterTab("topay");
                          }}
                        >
                          Limpar Filtro
                        </Button>
                      </Col>
                    </Row>
                  )}
                </Accordion2.Body>
              </Accordion2.Item>
            </Accordion2>

            <Row className="mt-4">
              <Col>
                <TabNotification
                  style={{ fontSize: ".8em" }}
                  options={[
                    { id: "topay", label: "A Pagar", value: null, show: true },
                    { id: "overdue", label: "Atrasados", value: null, show: true },
                    { id: "payed", label: "Pagos", value: null, show: true },
                    { id: "canceled", label: "Títulos Cancelados", value: null, show: true },
                    { id: "all", label: "Todos", value: null, show: true },
                  ]}
                  setActive={__ev => {
                    filterPreset(__ev);
                  }}
                  active={filterTab}
                  init={null}
                />
                {!isLoadingList ? (
                  negotiations?.data?.length > 0 ? (
                    <>
                      <TableResponsive
                        table={{
                          head: [
                            { data: "ID" },
                            { data: "Referente à" },
                            { data: "Descrição" },
                            { data: "Centro de Custo" },
                            { data: "Método" },
                            { data: "Valor Total" },
                            { data: "Parcelas" },
                            { data: <div className="text-end">Ações</div> },
                            { data: "" },
                          ],
                          body: negotiations?.data?.map(__negotiation => {
                            const _bills = __negotiation?.billToPays || [];
                            const _paid = _bills.filter(__bill => __bill.status === "pago");
                            const _next = _bills.find(__bill => __bill.status === "a-pagar");
                            return {
                              spoilerOnRowClick: true,
                              data: [
                                { element: <span>{__negotiation.id}</span> },
                                {
                                  element: (
                                    <span>
                                      <b>{payeeName(__negotiation)}</b>
                                      <br />
                                      <small>{PAYMENT_FOR_LABEL[__negotiation.payment_for]}</small>
                                      {__negotiation.payment_for === "empresa" && !!__negotiation.commercials && (
                                        <>
                                          <br />
                                          <small>Turma relacionada: {commercialLabel(__negotiation.commercials)}</small>
                                        </>
                                      )}
                                    </span>
                                  ),
                                },
                                { element: <span>{__negotiation.description || "-"}</span> },
                                {
                                  element: (
                                    <span>
                                      {__negotiation.costCenters?.name || "-"}
                                      {__negotiation.expenses?.name ? (
                                        <>
                                          <br />
                                          <small>{__negotiation.expenses?.name}</small>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </span>
                                  ),
                                },
                                { element: <span>{METHOD_LABEL[__negotiation.method_payment] || "-"}</span> },
                                { element: <span>{formatReal(__negotiation.value_total)}</span> },
                                {
                                  element: (
                                    <span>
                                      {!_next && _paid.length > 0 ? (
                                        <StatusFlag status="Pago">
                                          {_paid.length}/{__negotiation.total_quotas} pagas
                                        </StatusFlag>
                                      ) : (
                                        <>
                                          {_paid.length}/{__negotiation.total_quotas} pagas
                                        </>
                                      )}
                                      {_next ? (
                                        <>
                                          <br />
                                          {nextDueStatus(_next) ? (
                                            <Tooltip2 tip={nextDueTooltip[nextDueStatus(_next)]}>
                                              <StatusFlag status={nextDueStatus(_next)}>
                                                Próx: {formatDate(_next.due_date, 7)}
                                              </StatusFlag>
                                            </Tooltip2>
                                          ) : (
                                            <small>Próx: {formatDate(_next.due_date, 7)}</small>
                                          )}
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </span>
                                  ),
                                },
                                {
                                  element: (
                                    <div className="text-end">
                                      <Dropdown2
                                        toggle={<>...</>}
                                        menu={[
                                          ...(__negotiation.payment_for === "empresa"
                                            ? [
                                                {
                                                  label: "Informações de Pagamento",
                                                  action: () => {
                                                    setpaymentInfoNegotiation(__negotiation);
                                                  },
                                                },
                                              ]
                                            : []),
                                          ...(canUpdate && _bills.some(__bill => __bill.status === "a-pagar")
                                            ? [
                                                {
                                                  label: "Renegociar Título",
                                                  action: () => {
                                                    setmodalNegotiation({
                                                      open: true,
                                                      negotiation: __negotiation,
                                                    });
                                                  },
                                                },
                                                {
                                                  label: "Cancelar Título",
                                                  action: () => {
                                                    setcancelNegotiation(__negotiation);
                                                  },
                                                },
                                              ]
                                            : []),
                                          ...(canUpdate && _paid.length === 0
                                            ? [
                                                {
                                                  label: "Excluir",
                                                  action: () => {
                                                    setdeleteNegotiation(__negotiation);
                                                  },
                                                },
                                              ]
                                            : []),
                                        ]}
                                      />
                                    </div>
                                  ),
                                },
                                {
                                  element: (
                                    <div className="text-end pe-2">
                                      <SpoilerLink text="" />
                                    </div>
                                  ),
                                  spoiler: installmentsSpoiler(__negotiation),
                                },
                              ],
                              key: `negotiation-${__negotiation.id}`,
                            };
                          }),
                        }}
                      />
                      <Pagenation
                        current={negotiations?.page}
                        total={negotiations?.lastPage}
                        pageChange={__page => {
                          applyFilter(null, __page);
                        }}
                        className="mt-4"
                      />
                    </>
                  ) : (
                    <EmptyError text="Nenhum pagamento encontrado." />
                  )
                ) : (
                  <Loading className="mt-2" />
                )}
              </Col>
            </Row>
          </Content>
        ) : (
          <Content>
            <Loading />
          </Content>
        )}
      </Main>
    </>
  );
}
